<template>
  <KTCodePreview v-bind:title="'Thông tin phiếu yêu cầu nhập hàng'">
    <template v-slot:toolbar>
      <div class="row" v-if="mainModel.id">
        <div>
          <b-row
            class="mb-4 ml-4"
            style="vertical-align: middle; display: inline"
          >
            <b-button
              v-if="canSwitchReady"
              size="sm"
              variant="success"
              class="mr-2"
              @click="onSwitchReady"
            >
              <i class="fas fa-paper-plane"></i> Gửi duyệt
            </b-button>
            <b-button
              v-if="canSwitchPurchased"
              size="sm"
              variant="primary"
              class="mr-2"
              @click="onSwitchPurchased"
            >
              <i class="fas fa-check"></i> Trưởng ngành hàng duyệt
            </b-button>
            <b-button
              v-if="canSwitchAccountant"
              size="sm"
              variant="primary"
              class="mr-2"
              @click="onSwitchAccountant"
            >
              <i class="fas fa-check-double"></i> Kế toán duyệt
            </b-button>
            <b-button
              v-if="canCancel"
              size="sm"
              variant="danger"
              class="mr-2"
              @click="onCancel"
            >
              <i class="fas fa-times"></i> Huỷ
            </b-button>
            <b-dropdown size="sm" id="dropdown-1" right>
              <template slot="button-content">
                <i style="font-size: 1rem" class="fas fa-cog"></i>
                <span class="font-weight-bolder">Thao tác</span>
              </template>
              <b-dropdown-item @click="reportClick">
                <span>
                  <i style="font-size: 1rem" class="far fa-file-excel"></i>
                  &nbsp; Xuất Excel</span
                >
              </b-dropdown-item>
            </b-dropdown>
          </b-row>
        </div>
      </div>
    </template>
    <template v-slot:preview>
      <b-card no-body class="full-width">
        <div>
          <div
            class="wizard wizard-4"
            id="kt_wizard_v4"
            data-wizard-state="step-first"
            data-wizard-clickable="true"
          >
            <!--begin: Wizard Nav-->
            <div class="wizard-nav" style="background-color: #eef0f8">
              <div class="wizard-steps">
                <div
                  class="wizard-step"
                  data-wizard-type="step"
                  data-wizard-state="current"
                >
                  <div class="wizard-wrapper">
                    <div class="wizard-label">
                      <div class="wizard-title">Thông tin</div>
                    </div>
                  </div>
                </div>
                <div
                  class="wizard-step ml-1"
                  data-wizard-type="step"
                  v-show="mainModel.id"
                >
                  <div class="wizard-wrapper">
                    <div class="wizard-label">
                      <div class="wizard-title">Tệp đính kèm</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="rounded-top-0">
              <div class="p-0">
                <div class="row">
                  <div class="col-xl-12">
                    <div
                      class="py-8 px-4 py-lg-15 px-lg-4 pb-5 full-width"
                      data-wizard-type="step-content"
                      data-wizard-state="current"
                    >
                      <b-row class="mb-5">
                        <!-- INFO INPUT CONTROLS -->
                        <b-col cols="6">
                          <b-row v-if="mainModel.id">
                            <b-col>
                              <b-form-group>
                                <template>
                                  <span>Mã phiếu:</span>
                                </template>
                                <p class="mt-2">{{ mainModel.code }}</p>
                              </b-form-group>
                            </b-col>
                            <b-col>
                              <b-form-group>
                                <template>
                                  <span>Người tạo:</span>
                                </template>
                                <p class="mt-2">{{ mainModel.createdBy }}</p>
                              </b-form-group>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col>
                              <b-form-group>
                                <template>
                                  <span>Ngày tạo:</span>
                                </template>
                                <p class="mt-2">{{ mainModel.createdAt }}</p>
                              </b-form-group>
                            </b-col>
                            <b-col>
                              <b-form-group>
                                <template>
                                  <span>Tổng tiền:</span>
                                </template>
                                <p class="mt-2">
                                  {{ convertPrice(totalPrice) }}
                                </p>
                              </b-form-group>
                            </b-col>
                          </b-row>

                          <b-row>
                            <b-col>
                              <b-form-group
                                class="required-control"
                                :disabled="!editable"
                              >
                                <label>Kho:</label>
                                <Autosuggest
                                  :disabled="!isModeCreateNew"
                                  class="border-radius-none"
                                  :model="mainModel.storeName"
                                  :suggestions="filteredOptionStores"
                                  placeholder="kho"
                                  @select="onSelectedStore"
                                  @change="onInputChangeStore"
                                  suggestionName="suggestionName"
                                />
                                <small
                                  class="text-danger"
                                  v-if="checkErr && errors.storeId"
                                  >{{ errors.storeId }}</small
                                >
                              </b-form-group>
                            </b-col>
                            <b-col md="6">
                              <b-form-group
                                class="required-control"
                                :disabled="!editable"
                              >
                                <label>Nhà cung cấp:</label>
                                <div class="float-right">
                                  <span
                                    @click="
                                      showProviderModal = !showProviderModal
                                    "
                                    ><i
                                      class="fa fa-plus-circle text-primary pt-1"
                                      style="cursor: pointer"
                                    ></i
                                  ></span>
                                </div>
                                <Autosuggest
                                  class="border-radius-none"
                                  :model="mainModel.providerName"
                                  :suggestions="filteredOptionsProvider"
                                  placeholder="nhà cung cấp"
                                  :limit="200"
                                  @select="onSelectedProvider"
                                  @change="onInputChangeProvider"
                                  suggestionName="suggestionName"
                                />
                                <small
                                  class="text-danger"
                                  v-if="checkErr && errors.providerId"
                                  >{{ errors.providerId }}</small
                                >
                              </b-form-group>
                            </b-col>
                          </b-row>

                          <b-row>
                            <b-col>
                              <b-form-group :disabled="!editable">
                                <label>Lý do nhập hàng:</label>
                                <b-form-textarea
                                  size="sm"
                                  v-model="mainModel.importReason"
                                  :placeholder="'Nhập lý do nhập hàng...'"
                                  :rows="6"
                                  :max-rows="6"
                                ></b-form-textarea>
                              </b-form-group>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col>
                              <b-form-group>
                                <label>Ghi chú:</label>
                                <b-form-textarea
                                  size="sm"
                                  v-model="mainModel.description"
                                  :placeholder="'Thêm nội dung ghi chú...'"
                                  :rows="6"
                                  :max-rows="6"
                                ></b-form-textarea>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-col>
                        <!-- INFO VAT INPUT CONTROLS -->
                        <b-col cols="3">
                          <b-form-group :disabled="!editable">
                            <label>Hình thức thanh toán:</label>
                            <b-form-select
                              class="select-style"
                              v-model="mainModel.type"
                              :options="listImportType"
                              size="sm"
                              value-field="id"
                              text-field="name"
                            >
                            </b-form-select>
                          </b-form-group>
                          <b-form-group :disabled="!editable">
                            <label style="margin-bottom: 0.75rem"
                              >Chiết khấu:</label
                            >
                            <b-row>
                              <b-col class="pr-0" cols="5">
                                <b-form-select
                                  class="select-style"
                                  v-model="mainModel.discountType"
                                  :options="listAmountType"
                                  size="sm"
                                  value-field="id"
                                  text-field="name"
                                >
                                </b-form-select>
                              </b-col>
                              <b-col class="pl-0" cols="7">
                                <b-form-input
                                  class="input-style text-right"
                                  size="sm"
                                  v-model="mainModel.discountValue"
                                  v-mask="formater.currency"
                                  placeholder="Chiết khấu"
                                ></b-form-input>
                              </b-col>
                            </b-row>
                          </b-form-group>
                        </b-col>
                        <!-- PAYMENT INPUT CONTROLS -->
                        <b-col cols="3">
                          <POPayment
                            :editable="editable"
                            :mainModel="mainModel"
                            v-if="renderComponent"
                          />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="3">
                          <b-form-group :disabled="!editable">
                            <label>Người liên hệ:</label>
                            <Autosuggest
                              class="border-radius-none"
                              :model="mainModel.inChargeEmployeeName"
                              :suggestions="filteredOptionsEmployee"
                              placeholder="người liên hệ"
                              :limit="10"
                              @select="onSelectedEmployee"
                              @change="onInputChangeEmployee"
                              suggestionName="suggestionName"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col v-if="mainModel.id" cols="3">
                          <b-form-group :disabled="!editable">
                            <label>Nguồn :</label>
                            <b-form-select
                              class="select-style"
                              v-model="mainModel.sourceType"
                              :options="listSourceType"
                              disabled
                              size="sm"
                              value-field="id"
                              text-field="name"
                            >
                            </b-form-select>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row class="mb-4" v-if="editable">
                        <b-col md="2" class="pr-0">
                          <b-form-select
                            v-model="selectTypeSearch"
                            :options="listTypeSearch"
                            size="sm"
                            value-field="id"
                            text-field="name"
                          ></b-form-select>
                        </b-col>
                        <b-col md="6" class="pl-0 pr-0">
                          <treeselect
                            :load-options="loadOptions"
                            :multiple="true"
                            :async="true"
                            :disabled="!mainModel.storeId"
                            placeholder="Tìm kiếm theo tên, mã, mã vạch sản phẩm"
                            retryText="Thử lại..."
                            retryTitle="Nhấp thử lại"
                            searchPromptText="Nhập để tìm kiếm..."
                            loadingText="Đang tải..."
                            noResultsText="Không có kết quả"
                            :match-keys="['label', 'customLabel']"
                            v-model="selectedProducts"
                            :values="searchProduct"
                            :backspace-removes="false"
                            :clearable="false"
                            valueFormat="object"
                            :max-height="200"
                            @select="onSelectedProduct"
                          >
                            <label
                              slot="option-label"
                              slot-scope="{ node, labelClassName }"
                              :class="labelClassName"
                              class="border-bottom"
                            >
                              <span
                                class="text-primary d-block px-0"
                                v-if="node.raw.label"
                              >
                                {{ node.raw.label }}
                              </span>
                              <b
                                v-if="node.raw.customLabel"
                                class="d-block px-0"
                              >
                                {{ node.raw.customLabel }}</b
                              >
                            </label>
                          </treeselect>
                        </b-col>
                        <b-col md="1">
                          <b-button
                            style="width: 40px"
                            variant="secondary"
                            size="sm"
                            v-b-tooltip.hover
                            title="Thêm sản phẩm"
                            @click="onAddProduct"
                          >
                            <i class="fas fa-arrow-down"></i>
                          </b-button>
                        </b-col>
                        <b-col md="3">
                          <div class="d-flex justify-content-end">
                            <b-button
                              variant="secondary"
                              size="sm"
                              class="font-weight-bolder"
                              @click="showModalImportProduct"
                              :disabled="!mainModel.storeId"
                              v-if="editable"
                            >
                              <i
                                style="font-size: 1rem"
                                class="far fa-file-excel"
                              ></i
                              >Nhập SP từ excel
                            </b-button>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="8">
                          <span class="font-weight-bolder lable-size"
                            >Danh sách sản phẩm:</span
                          >
                        </b-col>
                        <b-col md="4">
                          <b-checkbox
                            v-model="mainModel.isVAT"
                            class="d-flex justify-content-end lable-size"
                            >Đơn giá đã bao gồm VAT
                          </b-checkbox>
                        </b-col>
                      </b-row>
                      <b-table
                        :fields="fieldProduct"
                        :items="listProductStock"
                        v-if="renderComponent"
                        hover
                        bordered
                        class="mt-4"
                      >
                        <template v-slot:cell(productName)="row">
                          <span
                            v-text="row.item.productCode"
                            style="font-size: 12px"
                            v-show="row.item.productCode"
                          ></span>
                          <br />
                          <span
                            v-text="row.item.productName"
                            style="white-space: normal; color: #3699ff"
                          ></span>
                          <br />
                          <span
                            class="badge badge-light-primary"
                            style="font-size: 10px"
                          >
                            Tồn kho: {{ row.item.inStockQuantity || 0 }}
                          </span>
                        </template>
                        <template v-slot:cell(quantity)="row">
                          <span
                            v-if="
                              mainModel.status ===
                              PURCHASE_ORDER_STATUS.ACCOUNTANT
                            "
                            >{{ convertPrice(row.item.quantity) }}</span
                          >
                          <b-input
                            v-else
                            type="text"
                            size="sm"
                            class="input-style text-right"
                            v-model="row.item.quantity"
                            v-mask="formater.currency"
                            @change="onChangeItemData(row.item.id)"
                          ></b-input>
                        </template>
                        <template v-slot:cell(quantityApprove)="row">
                          <!-- Editable chỉ khi Trưởng NH đang duyệt (status=READY).
                                 ACCOUNTANT (status=3) phải read-only — BR-001 data lock. -->
                          <b-input
                            v-if="
                              mainModel.status === PURCHASE_ORDER_STATUS.READY
                            "
                            type="text"
                            size="sm"
                            class="input-style text-right"
                            v-model="row.item.quantityApprove"
                            v-mask="formater.currency"
                          ></b-input>
                          <span v-else>{{
                            convertPrice(row.item.quantityApprove)
                          }}</span>
                        </template>
                        <template v-slot:cell(beforeVatPrice)="row">
                          <span
                            v-if="
                              mainModel.status ===
                              PURCHASE_ORDER_STATUS.ACCOUNTANT
                            "
                            >{{ convertPrice(row.item.beforeVatPrice) }}</span
                          >
                          <b-input
                            v-else
                            type="text"
                            size="sm"
                            class="input-style text-right"
                            v-model="row.item.beforeVatPrice"
                            v-mask="formater.currency"
                            @change="onChangeItemData(row.item.id)"
                          ></b-input>
                        </template>
                        <template v-slot:cell(vatLine)="row">
                          <span
                            v-if="
                              mainModel.status ===
                              PURCHASE_ORDER_STATUS.ACCOUNTANT
                            "
                          >
                            {{
                              row.item.vatType === DISCOUNT_TYPE.PERCENT
                                ? (row.item.vatValue || 0) + '%'
                                : convertPrice(row.item.vatValue || 0)
                            }}
                          </span>
                          <b-row v-else no-gutters>
                            <b-col cols="5" class="pr-0">
                              <b-form-select
                                class="select-style"
                                v-model="row.item.vatType"
                                :options="listAmountType"
                                size="sm"
                                value-field="id"
                                text-field="name"
                                @change="onChangeItemData(row.item.id)"
                              ></b-form-select>
                            </b-col>
                            <b-col cols="7" class="pl-0">
                              <b-input
                                type="text"
                                size="sm"
                                class="input-style text-right"
                                v-model="row.item.vatValue"
                                v-mask="formater.currency"
                                @change="onChangeItemData(row.item.id)"
                              ></b-input>
                            </b-col>
                          </b-row>
                        </template>
                        <template v-slot:cell(unitPrice)="row">
                          <span>{{ convertPrice(row.item.unitPrice) }}</span>
                          <small
                            v-if="
                              row.item.minPrice &&
                              Number(row.item.unitPrice) <
                                Number(row.item.minPrice)
                            "
                            class="text-danger d-block"
                            v-b-tooltip.hover
                            title="Đơn giá nhập thấp hơn giá nhập thấp nhất từng nhập"
                          >
                            Cảnh báo: giá thấp (Min:
                            {{ convertPrice(row.item.minPrice) }})
                          </small>
                          <small
                            v-else-if="row.item.minPrice"
                            class="text-muted d-block"
                          >
                            Min: {{ convertPrice(row.item.minPrice) }}
                          </small>
                        </template>
                        <template v-slot:cell(discountAmount)="row">
                          <span
                            v-if="
                              mainModel.status ===
                              PURCHASE_ORDER_STATUS.ACCOUNTANT
                            "
                            >{{ convertPrice(row.item.discountAmount) }}</span
                          >
                          <b-input
                            v-else
                            type="text"
                            size="sm"
                            class="input-style text-right"
                            v-model="row.item.discountAmount"
                            v-mask="formater.currency"
                            @change="onChangeItemData(row.item.id)"
                          ></b-input>
                        </template>
                        <template v-slot:cell(salePrice)="row">
                          <span
                            v-if="
                              mainModel.status ===
                              PURCHASE_ORDER_STATUS.ACCOUNTANT
                            "
                            >{{ convertPrice(row.item.salePrice) }}</span
                          >
                          <b-input
                            v-else
                            type="text"
                            size="sm"
                            class="input-style text-right"
                            v-model="row.item.salePrice"
                            v-mask="formater.currency"
                            @change="onChangeItemData(row.item.id)"
                          ></b-input>
                        </template>
                        <template v-slot:cell(actions)="row">
                          <v-icon
                            small
                            class="text-danger text-center"
                            @click="deleteItemInArray(row.item.id)"
                            v-b-tooltip
                            title="Xóa"
                            >mdi-delete</v-icon
                          >
                        </template>
                        <template v-slot:cell(salePower)="row">
                          <div>
                            <span class="font-weight-bold">Tuần:</span>
                            <span>{{ row.item.salePowerWeek || 0 }}</span>
                          </div>
                          <div>
                            <span class="font-weight-bold">Tháng:</span>
                            <span>{{ row.item.salePowerMonth || 0 }}</span>
                          </div>
                        </template>
                      </b-table>
                      <template
                        v-if="
                          mainModel &&
                          mainModel.status === PURCHASE_ORDER_STATUS.ACCOUNTANT
                        "
                      >
                        <hr
                          class="hr-text"
                          data-content="Phiếu nhập xuất kho"
                          style="font-weight: 600"
                        />
                        <POStockSlipTransaction
                          :purchase-order-id="mainModel.id"
                        />
                        <hr
                          class="hr-text"
                          data-content="Bút toán"
                          style="font-weight: 600"
                        />
                        <POTransactionPanel :purchase-order-id="mainModel.id" />
                      </template>
                      <hr
                        class="hr-text"
                        data-content="Lý do hủy phiếu"
                        style="font-weight: 600"
                      />
                      <b-row v-if="mainModel.code">
                        <b-col>
                          <CancelReason :stockCode="mainModel.code" />
                        </b-col>
                      </b-row>

                      <div class="col-md-12" style="padding-left: 0px">
                        <div class="mb-5 mt-5">
                          <b-button
                            v-if="checkEdit()"
                            v-bind:style="btnCreate"
                            size="sm"
                            variant="primary"
                            class="font-weight-bolder mr-4"
                            @click="onSubmit"
                          >
                            Lưu
                          </b-button>
                          <b-button
                            v-bind:style="btnCreate"
                            size="sm"
                            variant="secondary"
                            class="font-weight-bolder"
                            @click="onBack"
                          >
                            Hủy
                          </b-button>
                        </div>
                        <b-modal
                          v-model="showProviderModal"
                          hide-footer
                          title="Thêm mới nhà cung cấp"
                        >
                          <b-row class="mb-5">
                            <b-col>
                              <label class="labelInput"
                                >Tên nhà cung cấp:</label
                              >
                              <b-form-input
                                v-model="providerName"
                                size="sm"
                                placeholder="Nhập tên nhà cung cấp"
                              ></b-form-input>
                            </b-col>
                            <b-col>
                              <label class="labelInput"
                                >Số điện thoại nhà cung cấp:</label
                              >
                              <b-form-input
                                v-model="providerPhone"
                                size="sm"
                                placeholder="Nhập số điện thoại nhà cung cấp"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col>
                              <b-button
                                style="font-weight: 600; width: 70px"
                                variant="primary"
                                size="sm"
                                @click="createProvider()"
                                >Lưu</b-button
                              >
                              <b-button
                                @click="showProviderModal = !showProviderModal"
                                style="
                                  margin-left: 10px;
                                  font-weight: 600;
                                  width: 70px;
                                "
                                variant="secondary"
                                size="sm"
                                >Hủy</b-button
                              >
                            </b-col>
                          </b-row>
                        </b-modal>
                        <ImportProductPOModal
                          ref="stock-slip-excel"
                          :storeId="mainModel.storeId"
                          v-on:validData="validData"
                        />
                        <CancelPO
                          ref="po-cancel"
                          :purchaseOrderCode="mainModel.code"
                          :purchaseOrderId="mainModel.id"
                          :purchaseOrderStatus="mainModel.status"
                          v-on:onSuccess="onCancelSuccess"
                        />
                      </div>
                    </div>

                    <div
                      class="py-4 mb-5 full-width"
                      data-wizard-type="step-content"
                    >
                      <div class="upload-file col-12">
                        <UploadFile
                          v-if="mainModel.id"
                          :id="mainModel.id"
                          :entity="'purchase-orders'"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end: Wizard Nav -->
      </b-card>
    </template>
  </KTCodePreview>
</template>

<style>
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}
.table.b-table.table-sm > thead > tr > [aria-sort]:not(.b-table-sort-icon-left),
.table.b-table.table-sm
  > tfoot
  > tr
  > [aria-sort]:not(.b-table-sort-icon-left) {
  background-position: right calc(1.5rem / 2) center;
  padding-right: calc(0.3rem + 0.65em);
}
</style>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import moment from 'moment';
import ApiService from '@/core/services/api.service';
import PurchaseOrderService from '@/core/api/purchase-order/purchase-order.service';
import { PurchaseOrderModel } from '@/core/models/PurchaseOrder.model';
import { validationMixin } from 'vuelidate';
import {
  currencyMask,
  unMaskPrice,
  convertPrice,
  makeToastFaile,
  makeToastSuccess,
  convertToNumber,
  xoa_dau,
  formatDate,
} from './../../../utils/common';
import { getCurrentDate } from './../../../utils/date';
import { PURCHASE_ORDER_TYPE, TIME_TRIGGER } from './../../../utils/constants';
import {
  API_RESPONSE_STATUS,
  DISCOUNT_TYPE,
  PERMISSIONS,
  PRODUCT_TYPE_ENUM,
  PURCHASE_ORDER_STATUS,
} from './../../../utils/enum';

import decounce from 'debounce';
import ImportProductPOModal from '../../components/purchase-orders/ImportProductPOModal';
import POStockSlipTransaction from '@/view/components/purchase-orders/POStockSlipTransaction.vue';
import POTransactionPanel from '@/view/components/purchase-orders/POTransactionPanel.vue';
import CancelReason from '../../components/stock-slips/CancelReason';
import CancelPO from '../../components/stock-slips/CancelPO';
import { v4 } from 'uuid';
import KTWizard from '@/assets/js/components/wizard';
import KTUtil from '@/assets/js/components/util';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import fileDownload from '../../../utils/file-download';
import UploadFile from '@/view/modules/upload/Upload';
import POPayment from '../../components/purchase-orders/POPayment';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import swalMixin from '@/view/mixins/toast.mixins';
import { permissionMixin } from '@/view/mixins/permission.mixins';

// Style chung cho mọi <th> trong lưới sản phẩm — hoist để tránh lặp inline.
const HEADER_STYLE = { fontWeight: 600, color: '#181c32' };
const headerStyle = (width) => ({ ...HEADER_STYLE, width });

export default {
  mixins: [validationMixin, swalMixin, permissionMixin],
  data() {
    return {
      // Enums (expose để template/computed dùng qua this.X)
      PERMISSIONS,
      PURCHASE_ORDER_STATUS,
      API_RESPONSE_STATUS,
      PRODUCT_TYPE_ENUM,
      DISCOUNT_TYPE,
      btnCreate: {
        fontWeight: '600!important',
        'margin-right': '-10px',
        width: '70px',
      },
      isSubmitting: false,
      searchProduct: '',
      listTypeSearch: [
        {
          id: null,
          name: 'Tất cả loại sản phẩm',
        },
      ],
      selectTypeSearch: null,
      listProductStock: [],
      filteredOptionStores: [],
      optionStores: [],
      formater: {
        currency: currencyMask,
      },
      showProviderModal: false,
      providerName: '',
      providerPhone: '',
      filteredOptionsProvider: [],
      optionsProvider: [],
      isSearching: false,
      listAmountType: [
        { id: DISCOUNT_TYPE.PERCENT, name: '%' },
        { id: DISCOUNT_TYPE.AMOUNT, name: '$' },
      ],
      fieldProduct: [
        {
          key: 'productName',
          label: 'Sản phẩm',
          sortable: false,
          thStyle: headerStyle('10%'),
          tdClass: 'text-left',
        },
        {
          key: 'prevUnitPrice',
          label: 'Giá thấp nhất',
          sortable: false,
          thStyle: headerStyle('10%'),
          tdClass: 'text-right',
          formatter: (v) => (v ? convertPrice(v) : 0),
        },
        {
          key: 'salePower',
          label: 'Sức bán',
          sortable: false,
          thStyle: headerStyle('10%'),
          tdClass: 'text-left',
        },
        {
          key: 'quantity',
          label: 'SL',
          sortable: false,
          thStyle: headerStyle('7%'),
          tdClass: 'text-right',
        },
        {
          key: 'quantityApprove',
          label: 'SL đáp ứng',
          sortable: false,
          thStyle: headerStyle('7%'),
          tdClass: 'text-right',
        },
        {
          key: 'beforeVatPrice',
          label: 'Giá trước VAT',
          sortable: false,
          thStyle: headerStyle('12%'),
          tdClass: 'text-right',
        },
        {
          key: 'vatLine',
          label: 'VAT',
          sortable: false,
          thStyle: headerStyle('12%'),
          tdClass: 'text-right',
        },
        {
          key: 'unitPrice',
          label: 'Đơn giá (VAT)',
          sortable: false,
          thStyle: headerStyle('10%'),
          tdClass: 'text-right',
        },
        {
          key: 'totalAmount',
          label: 'Thành tiền',
          sortable: false,
          thStyle: headerStyle('11%'),
          tdClass: 'text-right',
          formatter: (v) => (v ? convertPrice(v) : 0),
        },
        {
          key: 'salePrice',
          label: 'Đơn giá bán',
          sortable: false,
          thStyle: headerStyle('15%'),
          tdClass: 'text-right',
          formatter: (v) => (v ? convertPrice(v) : 0),
        },
      ],
      renderComponent: true,
      mainModel: {
        id: null,
        code: '',
        status: 1,
        providerId: null,
        providerName: '',
        description: '',
        storeId: null,
        storeName: '',
        discountValue: 0,
        discountType: DISCOUNT_TYPE.PERCENT,
        cashAmount: 0,
        cashAccountCode: '',
        cashAccountId: null,
        cashAccountName: '',
        transferAmount: 0,
        transferAccountCode: '',
        transferAccountId: null,
        transferAccountName: '',
        payDate: null,
        vatCode: '',
        vatDate: '',
        createdAt: '',
        createdBy: '',
        type: 1,
        importReason: '',
        isNew: true,
        isVAT: true,
        inChargeEmployeeName: '',
        inChargeEmployeeId: null,
        sourceType: null,
      },
      listImportType: PURCHASE_ORDER_TYPE,
      hashName: null,
      filteredOptionsEmployee: [],
      optionsEmployee: [],
      searchEmployee: '',
      listEmployeeSearch: [],
      selectedProducts: [],
      listSourceType: [
        { id: null, name: 'Nguồn PO' },
        {
          id: 1,
          name: 'Cửa hàng',
        },
        {
          id: 2,
          name: 'Ngành hàng',
        },
      ],
      checkErr: false,
    };
  },
  components: {
    KTCodePreview,
    ImportProductPOModal,
    POStockSlipTransaction,
    POTransactionPanel,
    CancelReason,
    CancelPO,
    Treeselect,
    UploadFile,
    POPayment,
    Autosuggest,
  },
  created() {
    this.fetchStoreByUser();
    this.fetchProvider();
    this.fetchEmployee();
  },
  mounted() {
    this.mainModel.createdAt = getCurrentDate();
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Phiếu yêu cầu nhập hàng', route: '/purchase-orders' },
      { title: 'Thông tin phiếu yêu cầu nhập hàng' },
    ]);
    if (this.$route.query.id) {
      this.mainModel.id = this.$route.query.id;
      this.mainModel.isNew = !!this.$route.query.isCreate;
      this.getInfoById();
    } else {
      if (!this.fieldProduct.find((f) => f.key === 'actions')) {
        this.fieldProduct.push({
          key: 'actions',
          label: '',
          thStyle: { ...headerStyle('5%'), textAlign: 'center' },
          tdClass: 'text-center',
        });
      }
    }
    // Initialize form wizard
    const hashName = this.$route.hash ? this.$route.hash.split('#')[1] : '';

    this.hashName = hashName === 'attach' ? 'attach' : null;

    const wizard = new KTWizard('kt_wizard_v4', {
      startStep: hashName === 'attach' ? 3 : 1, // initial active step number
      clickableSteps: true, // allow step clicking
    });

    wizard.on('beforeNext', function (/*wizardObj*/) {});

    wizard.on('change', function (/*wizardObj*/) {
      setTimeout(() => {
        KTUtil.scrollTop();
      }, 500);
    });
  },
  computed: {
    canSwitchReady() {
      return (
        !!this.mainModel.id &&
        this.mainModel.status === this.PURCHASE_ORDER_STATUS.NEW &&
        this.hasPermission(this.PERMISSIONS.PO_UPDATE)
      );
    },
    canSwitchPurchased() {
      return (
        !!this.mainModel.id &&
        this.mainModel.status === this.PURCHASE_ORDER_STATUS.READY &&
        this.hasPermission(this.PERMISSIONS.PO_PURCHASE_APPROVE)
      );
    },
    canSwitchAccountant() {
      return (
        !!this.mainModel.id &&
        this.mainModel.status === this.PURCHASE_ORDER_STATUS.PURCHASED &&
        this.hasPermission(this.PERMISSIONS.PO_ACCOUNT_APPROVE)
      );
    },
    canCancel() {
      const s = this.mainModel.status;
      return (
        !!this.mainModel.id &&
        s !== this.PURCHASE_ORDER_STATUS.ACCOUNTANT &&
        s !== this.PURCHASE_ORDER_STATUS.CANCELED &&
        this.hasPermission(this.PERMISSIONS.PO_CANCEL)
      );
    },
    totalPrice() {
      // Per-line VAT mode: tổng VAT = Σ line.vatAmount theo từng vatType.
      // Discount header apply trước VAT (accounting VN).
      let totalGoods = 0;
      let totalLineVat = 0;
      for (const el of this.listProductStock) {
        const beforeVat = Number(unMaskPrice(el.beforeVatPrice)) || 0;
        const qty = Number(unMaskPrice(el.quantity)) || 0;
        const discount = Number(unMaskPrice(el.discountAmount)) || 0;
        const vatVal = Number(unMaskPrice(el.vatValue)) || 0;

        totalGoods += beforeVat * qty - discount;

        if (el.vatType === DISCOUNT_TYPE.PERCENT) {
          totalLineVat += (beforeVat * qty * vatVal) / 100;
        } else if (el.vatType === DISCOUNT_TYPE.AMOUNT) {
          totalLineVat += vatVal;
        }
      }

      const discountValue = this.mainModel.discountValue
        ? unMaskPrice(this.mainModel.discountValue)
        : 0;
      const headerDiscount =
        this.mainModel.discountType === DISCOUNT_TYPE.PERCENT
          ? (discountValue * totalGoods) / 100
          : discountValue;

      return parseInt(totalGoods - headerDiscount + totalLineVat);
    },
    totalDiscount() {
      let total = 0;
      for (let index = 0; index < this.listProductStock.length; index++) {
        const element = this.listProductStock[index];
        total += unMaskPrice(element.discountAmount) * 1;
      }
      return total;
    },
    totalQuantity() {
      let total = 0;
      for (let index = 0; index < this.listProductStock.length; index++) {
        const element = this.listProductStock[index];
        total += element.quantity * 1;
      }
      return total;
    },
    editable() {
      // XMĐ: BE chỉ cho update header/detail khi PO ở NEW hoặc READY.
      const s = this.mainModel.status;
      return (
        s === PURCHASE_ORDER_STATUS.NEW || s === PURCHASE_ORDER_STATUS.READY
      );
    },
    isModeCreateNew() {
      return !this.$route.query.id;
    },
    errors() {
      const errors = {};
      if (!this.mainModel.storeId) {
        errors.storeId = 'Vui lòng nhập kho!';
      }

      if (!this.mainModel.providerId) {
        errors.providerId = 'Vui lòng chọn nhà cung cấp!';
      }
      return errors;
    },
  },
  methods: {
    convertPrice,
    forceRerender() {
      this.renderComponent = false;

      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
    // Resolve employee name từ optionsEmployee — gọi khi list employee load xong
    // sau khi PO đã load (race condition fix).
    _resolveEmployeeName() {
      if (!this.mainModel.inChargeEmployeeId) return;
      const emp = this.optionsEmployee.find(
        (e) => e.id === this.mainModel.inChargeEmployeeId,
      );
      if (emp) {
        this.mainModel.inChargeEmployeeName = emp.name;
        this.searchEmployee = emp.name;
      }
    },
    onSelectedProduct(option) {
      this.getPrevPriceByProductId(option.id);
    },
    onInputChangProduct(text) {
      if (!text) {
        text = '';
      }
      this.searchProduct = text;
      this.debounceInputProduct();
    },
    validatePayload() {
      if (Object.keys(this.errors).length !== 0) {
        return;
      }
      if (!this.listProductStock || !this.listProductStock.length) {
        return makeToastFaile('Vui lòng nhập sản phẩm!');
      }

      for (let item of this.listProductStock) {
        const { productName, quantity, beforeVatPrice } = item;

        if (
          !quantity ||
          convertToNumber({ value: unMaskPrice(quantity) }) <= 0
        ) {
          return makeToastFaile(
            `Vui lòng nhập số lượng của sản phẩm ${productName}!`,
          );
        }
        if (
          !beforeVatPrice ||
          convertToNumber({ value: unMaskPrice(beforeVatPrice) }) <= 0
        ) {
          return makeToastFaile(
            `Vui lòng nhập giá cho sản phẩm ${productName}!`,
          );
        }
      }
      const cashAmt = Number(unMaskPrice(this.mainModel.cashAmount)) || 0;
      if (cashAmt > 0 && !this.mainModel.cashAccountId) {
        return makeToastFaile('Vui lòng chọn tài khoản tiền mặt!');
      }
      const transferAmt =
        Number(unMaskPrice(this.mainModel.transferAmount)) || 0;
      if (transferAmt > 0 && !this.mainModel.transferAccountId) {
        return makeToastFaile('Vui lòng chọn tài khoản chuyển khoản!');
      }
      return true;
    },
    onSubmit: async function () {
      this.checkErr = true;
      if (!this.validatePayload()) return;
      if (this.mainModel.id) {
        this.onUpdate();
      } else {
        this.onCreate();
      }
    },
    _buildPayloadForBE(isUpdate = false) {
      const details = this.listProductStock.map((el) => {
        const d = {
          productId: el.productId,
          quantity: el.quantity ? Number(unMaskPrice(el.quantity)) : 0,
          unitPrice: el.unitPrice ? Number(unMaskPrice(el.unitPrice)) : 0,
          discountAmount: el.discountAmount
            ? Number(unMaskPrice(el.discountAmount))
            : 0,
          beforeVatPrice: el.beforeVatPrice
            ? Number(unMaskPrice(el.beforeVatPrice))
            : 0,
          prevUnitPrice: el.prevUnitPrice ? Number(el.prevUnitPrice) : 0,
          salePowerWeek: Number(el.salePowerWeek) || 0,
          salePowerMonth: Number(el.salePowerMonth) || 0,
          salePrice: el.salePrice ? Number(unMaskPrice(el.salePrice)) : 0,
          vatType: el.vatType || null,
          vatValue: el.vatValue ? Number(unMaskPrice(el.vatValue)) : 0,
        };
        if (isUpdate && el.id && !el.isNew) d.id = el.id;
        return d;
      });

      const discountValue = this.mainModel.discountValue
        ? Number(unMaskPrice(this.mainModel.discountValue))
        : 0;

      return {
        storeId: this.mainModel.storeId,
        providerId: this.mainModel.providerId,
        type: this.mainModel.type,
        description: this.mainModel.description,
        importReason: this.mainModel.importReason,
        inChargeEmployeeId: this.mainModel.inChargeEmployeeId,
        details,
        cashAmount: this.mainModel.cashAmount
          ? Number(unMaskPrice(this.mainModel.cashAmount))
          : 0,
        cashAccountId: this.mainModel.cashAccountId || null,
        cashAccountCode: this.mainModel.cashAccountCode || null,
        transferAmount: this.mainModel.transferAmount
          ? Number(unMaskPrice(this.mainModel.transferAmount))
          : 0,
        transferAccountId: this.mainModel.transferAccountId || null,
        transferAccountCode: this.mainModel.transferAccountCode || null,
        vatCode: this.mainModel.vatCode,
        vatSerial: this.mainModel.vatSerial,
        vatDate: (() => {
          if (!this.mainModel.vatDate) return null;
          // Date-picker có thể emit 'DD/MM/YYYY', ISO string hoặc Date object →
          // parse đa format (strict 1 format trước đó làm value bị null).
          const d = moment(this.mainModel.vatDate, [
            'DD/MM/YYYY',
            'YYYY-MM-DD',
            moment.ISO_8601,
          ]);
          return d.isValid() ? d.format('YYYY-MM-DD') : null;
        })(),
        discountType: this.mainModel.discountType || null,
        discountValue,
        payDate: (() => {
          if (!this.mainModel.payDate) return null;
          // Date-picker có thể emit 'DD/MM/YYYY', ISO string hoặc Date object →
          // parse đa format (strict 'DD/MM/YYYY' trước đó làm payDate bị null).
          const d = moment(this.mainModel.payDate, [
            'DD/MM/YYYY',
            'YYYY-MM-DD',
            moment.ISO_8601,
          ]);
          return d.isValid() ? d.format('YYYY-MM-DD') : null;
        })(),
        // BE DTO @IsBoolean() reject number — ép boolean để chắc chắn
        isVAT: Boolean(this.mainModel.isVAT),
      };
    },
    async onCreate() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      try {
        const payload = this._buildPayloadForBE(false);
        const { data } = await PurchaseOrderService.create(payload);
        if (data.status === API_RESPONSE_STATUS.SUCCESS) {
          makeToastSuccess(data.message || 'Tạo phiếu thành công');
          // Stay on page: chuyển sang chế độ edit với id mới + refetch.
          const newId = data.data?.id;
          if (newId) {
            this.mainModel.id = newId;
            this.mainModel.isNew = false;
            await this.$router
              .replace({
                name: 'info-purchase-orders',
                query: { id: newId },
              })
              .catch(() => {});
            await this.getInfoById();
          } else {
            console.warn('Tạo PO thành công nhưng không nhận được id');
          }
        } else {
          makeToastFaile(data.message);
        }
      } catch (err) {
        const msg = err.response?.data?.message || err.message;
        makeToastFaile(msg);
      } finally {
        this.isSubmitting = false;
      }
    },
    async onUpdate() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      try {
        const payload = this._buildPayloadForBE(true);
        const id = this.mainModel.id;
        const { data } = await PurchaseOrderService.update(id, payload);
        if (data.status === API_RESPONSE_STATUS.SUCCESS) {
          makeToastSuccess(data.message || 'Cập nhật thành công');
          // Stay on page: refetch để form sync với BE.
          await this.getInfoById();
        } else {
          makeToastFaile(data.message);
        }
      } catch (err) {
        const msg = err.response?.data?.message || err.message;
        makeToastFaile(msg);
      } finally {
        this.isSubmitting = false;
      }
    },
    // P6: workflow success → refetch để mainModel hydrate đầy đủ (status,
    // approver, history...) → computed canSwitch* react đúng → button update.
    async _callWorkflow(fn, successMsg) {
      try {
        const { data } = await fn();
        if (data.status === API_RESPONSE_STATUS.SUCCESS) {
          makeToastSuccess(successMsg);
          await this.getInfoById();
        } else {
          makeToastFaile(data.message || 'Có lỗi xảy ra');
        }
      } catch (err) {
        const msg = err.response?.data?.message || err.message;
        makeToastFaile(msg);
      }
    },
    async onSwitchReady() {
      const r = await this.popupSwalWarning({
        title: 'Gửi duyệt phiếu?',
        text: 'Sau khi gửi, phiếu chuyển sang trạng thái chờ duyệt và không thể xoá.',
      });
      if (!r.value) return;
      await this._callWorkflow(
        () => PurchaseOrderService.switchReady(this.mainModel.id),
        'Đã gửi duyệt',
      );
    },
    async onSwitchPurchased() {
      const r = await this.popupSwalWarning({
        title: 'Trưởng ngành hàng duyệt phiếu?',
        text: 'Hệ thống sẽ chốt số lượng duyệt theo grid hiện tại.',
      });
      if (!r.value) return;
      const payload = {
        items: this.listProductStock
          .map((p) => ({
            detailId: Number(p.id) > 0 ? Number(p.id) : null,
            quantityApprove: Number(p.quantityApprove ?? p.quantity ?? 0),
          }))
          .filter((i) => i.detailId != null),
      };
      await this._callWorkflow(
        () => PurchaseOrderService.switchPurchased(this.mainModel.id, payload),
        'Đã duyệt cấp Ngành hàng',
      );
    },
    async onSwitchAccountant() {
      const r = await this.popupSwalWarning({
        title: 'Kế toán duyệt phiếu?',
        text: 'Phiếu sẽ bị khoá sau khi duyệt và hệ thống tự động tạo phiếu yêu cầu nhập kho + bút toán tương ứng. Tiếp tục?',
      });
      if (!r.value) return;
      await this._callWorkflow(
        () => PurchaseOrderService.switchAccountant(this.mainModel.id, {}),
        'Đã duyệt cấp Kế toán',
      );
    },
    onCancel() {
      // Dùng CancelPO modal (cùng pattern List.vue) để có 2 dropdown
      // Loại trả phiếu + Lý do hủy. Payload đầy đủ qua component đó.
      this.$refs['po-cancel'].showModal();
    },
    async onCancelSuccess() {
      makeToastSuccess('Đã huỷ phiếu');
      await this.getInfoById();
    },
    async fetchProvider() {
      try {
        const { data } = await ApiService.get(`providers/getAll`);
        // BE XMĐ trả array trực tiếp (D-Core legacy trả {providers: [...]})
        const providers = Array.isArray(data.data)
          ? data.data
          : data.data?.providers || [];
        this.optionsProvider = providers.map((element) => ({
          id: element.id,
          name: element.name,
          suggestionName: element.name,
          numPaymentDate: element.numPaymentDate,
        }));
        this.filteredOptionsProvider = [...this.optionsProvider];
      } catch {
        this.optionsProvider = [];
        this.filteredOptionsProvider = [];
      }
    },
    async fetchProduct(textSearch) {
      this.isSearching = true;

      // P1 BE chưa có purchase-order/search-product (P4).
      // Tạm dùng products/search (BE param: productName, isCheckStock=0 để cho phép SP tồn=0).
      const params = {
        storeId: this.mainModel.storeId,
        productName: textSearch,
        isCheckStock: 0,
      };

      try {
        const { data } = await ApiService.query('products/search', { params });
        return data.data || [];
      } catch {
        return [];
      }
    },
    deleteItemInArray(id) {
      for (var i = 0; i < this.listProductStock.length; i++) {
        if (this.listProductStock[i].id === id) {
          this.listProductStock.splice(i, 1);
        }
      }
    },
    onChangeStore() {
      if (this.mainModel.isNew && !this.$route.query.isCreate) {
        this.listProductStock = [];
        this.selectedProducts = [];
      } else {
        const productIds = this.listProductStock.map(
          (productStock) => productStock.productId,
        );
        this.getPowerSaleByProductId(productIds);
      }
    },
    onSelectedStore(option) {
      this.mainModel.storeName = option.item.name;
      this.mainModel.storeId = option.item.id;
      this.onChangeStore();
    },
    onInputChangeStore(text) {
      this.mainModel.storeName = text;
      const filteredData = this.optionStores.filter(
        (item) =>
          item.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
          item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1,
      );
      this.filteredOptionStores = filteredData;
    },
    onSelectedProvider(option) {
      this.mainModel.providerName = option.item.name;
      this.mainModel.providerId = option.item.id;
      const numDate = option.item.numPaymentDate;
      if (numDate > 0) {
        this.mainModel.payDate = moment()
          .add(numDate, 'days')
          .format('DD/MM/YYYY');
      }
      if (!numDate) {
        this.mainModel.payDate = '';
      }
    },
    onInputChangeProvider(text) {
      this.mainModel.providerName = text;
      const filteredData = this.optionsProvider
        .filter((item) => {
          return item.name.toLowerCase().indexOf(text.toLowerCase()) > -1;
        })
        .slice(0, 10);
      this.filteredOptionsProvider = [...filteredData];
    },
    createProvider: async function () {
      if (!this.providerName) {
        return;
      }

      const data = {
        name: this.providerName,
        phoneNo: this.providerPhone,
        status: 1,
      };

      try {
        const response = await ApiService.post('providers', data);
        const { status, message } = response.data.data;
        if (status === API_RESPONSE_STATUS.SUCCESS) {
          await this.fetchProvider();
          this.showProviderModal = !this.showProviderModal;
          makeToastSuccess(message);
        } else {
          this.showProviderModal = !this.showProviderModal;
          makeToastFaile(message);
        }
      } catch (err) {
        const msg = err.response?.data?.message || err.message;
        makeToastFaile(msg);
      }
    },
    searchProductAPI() {
      if (!this.isSearching) {
        const textSearch = this.searchProduct;
        this.fetchProduct(textSearch);
      }
    },
    debounceInputProduct: decounce(function () {
      this.searchProductAPI();
    }, TIME_TRIGGER),
    async fetchStoreByUser() {
      try {
        const { data } = await ApiService.get(`stores/get-by-user`);
        if (data.status === API_RESPONSE_STATUS.SUCCESS) {
          const stores = data.data.stores;
          if (stores.length === 1) {
            this.mainModel.storeId = stores[0].id;
            this.mainModel.storeName = stores[0].name;
          } else {
            this.optionStores = stores.map((element) => {
              return {
                id: element.id,
                name: element.name,
                shortName: element.shortName,
                suggestionName: element.shortName + ' ( ' + element.name + ')',
              };
            });
            this.filteredOptionStores = [...this.optionStores];
          }
        }
      } catch {
        // fail-safe: danh sách kho rỗng, không block trang
      }
    },
    showModalImportProduct() {
      this.$refs['stock-slip-excel'].showModal();
    },
    validData(data) {
      // Map item import (BE trả `unitPrice`) sang shape grid Info.vue: cột giá
      // editable là `beforeVatPrice`, `unitPrice`/`totalAmount` được tính lại.
      // Mặc định không áp VAT theo dòng (vatType=null) — user chỉnh sau nếu cần.
      const mapped = (data || []).map((it) => {
        const beforeVat = Number(it.unitPrice) || 0;
        const qty = Number(it.quantity) || 0;
        const discount = Number(it.discountAmount) || 0;
        return {
          ...it,
          beforeVatPrice: beforeVat,
          unitPrice: beforeVat,
          vatType: null,
          vatValue: 0,
          vatAmount: 0,
          quantityApprove: qty,
          minPrice: it.minPrice || 0,
          totalAmount: beforeVat * qty - discount,
        };
      });
      this.listProductStock = this.listProductStock.concat(mapped);
    },
    onChangeItemData(id) {
      // VAT compute per-line (Info.vue mode — header không còn dùng).
      // PERCENT: lineVat = beforeVat * qty * vatValue/100
      // AMOUNT:  lineVat = vatValue (cố định cả dòng, không nhân qty)
      const item = this.listProductStock.find((x) => x.id === id);
      const beforeVat = Number(unMaskPrice(item.beforeVatPrice)) || 0;
      const qty = Number(unMaskPrice(item.quantity)) || 0;
      const discount = Number(unMaskPrice(item.discountAmount)) || 0;
      const vatVal = Number(unMaskPrice(item.vatValue)) || 0;

      let lineVatAmount = 0;
      if (item.vatType === DISCOUNT_TYPE.PERCENT) {
        lineVatAmount = (beforeVat * qty * vatVal) / 100;
      } else if (item.vatType === DISCOUNT_TYPE.AMOUNT) {
        lineVatAmount = vatVal;
      }

      const lineSubtotal = beforeVat * qty - discount;
      item.unitPrice = beforeVat;
      item.vatAmount = lineVatAmount;
      item.totalAmount = lineSubtotal + lineVatAmount;
      item.quantityApprove = qty;
    },
    onBack() {
      this.$router.push({
        name: 'list-purchase-orders',
      });
    },
    async getInfoById() {
      try {
        const { data } = await PurchaseOrderService.getById(this.mainModel.id);
        const po = PurchaseOrderModel.fromJson(data.data);
        if (!po) {
          makeToastFaile('Không tìm thấy phiếu');
          return;
        }

        this.mainModel.status = po.status || 1;
        this.mainModel.code = po.code || '';
        this.mainModel.description = po.description || '';
        this.mainModel.importReason = po.importReason || '';
        this.mainModel.storeName = po.store?.name || '';
        this.mainModel.storeId = po.storeId;
        this.mainModel.providerName = po.provider?.name || '';
        this.mainModel.providerId = po.providerId;
        this.mainModel.createdBy = po.createdByUser?.fullName || '';
        this.mainModel.inChargeEmployeeId = po.inChargeEmployeeId;
        // BE chưa eager-load employee → resolve name từ list đã fetch.
        const emp = this.optionsEmployee.find(
          (e) => e.id === po.inChargeEmployeeId,
        );
        this.mainModel.inChargeEmployeeName = emp ? emp.name : '';
        this.searchEmployee = this.mainModel.inChargeEmployeeName;
        this.mainModel.createdAt = formatDate(
          po.createdAt,
          'HH:mm:ss DD/MM/YYYY',
        );

        // VAT giờ per-line — không hydrate header. Discount header vẫn giữ.
        this.mainModel.discountType = po.discountType || DISCOUNT_TYPE.AMOUNT;
        this.mainModel.discountValue = po.discountValue || 0;

        this.mainModel.isVAT = Boolean(po.isVAT);
        // v-mask chỉ trigger khi user typing — format thủ công khi hydrate
        // để input hiển thị "5,000,000" thay vì "5000000".
        this.mainModel.cashAmount = po.cashAmount
          ? convertPrice(po.cashAmount)
          : 0;
        this.mainModel.cashAccountCode = po.cashAccountCode || '';
        this.mainModel.cashAccountId = po.cashAccountId || null;
        this.mainModel.transferAmount = po.transferAmount
          ? convertPrice(po.transferAmount)
          : 0;
        this.mainModel.transferAccountCode = po.transferAccountCode || '';
        this.mainModel.transferAccountId = po.transferAccountId || null;
        this.mainModel.payDate = formatDate(po.payDate, 'DD/MM/YYYY');
        this.mainModel.vatDate = formatDate(po.vatDate, 'DD/MM/YYYY');
        this.mainModel.vatCode = po.vatCode || '';
        this.mainModel.vatSerial = po.vatSerial || '';
        this.mainModel.type = po.type || 1;
        this.mainModel.sourceType = po.sourceType || null;

        // po.details là PurchaseOrderDetailModel[] đã hydrate (flat productName/code).
        // Spread vào shape cho table — chỉ override `isNew` theo mode hiện tại.
        this.listProductStock = po.details.map((d) => ({
          ...d,
          isNew: this.mainModel.isNew,
        }));

        if (this.mainModel.isNew) {
          this.mainModel.id = null;
          this.mainModel.status = PURCHASE_ORDER_STATUS.NEW;
        }

        // Action column (xoá dòng SP) chỉ hiện khi PO còn editable.
        if (
          this.editable &&
          !this.fieldProduct.find((f) => f.key === 'actions')
        ) {
          this.fieldProduct.push({
            key: 'actions',
            label: '',
            thStyle: { ...headerStyle('5%'), textAlign: 'center' },
            tdClass: 'text-center',
          });
        }
      } catch (err) {
        const msg =
          err.response?.data?.message || err.message || 'Không tải được phiếu';
        makeToastFaile(msg);
      }
    },
    onInputChangeEmployee(text) {
      if (!text) {
        text = '';
      }
      this.mainModel.inChargeEmployeeName = text;
      /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
      const filteredData = this.optionsEmployee
        .filter((item) => {
          const nameNoneSign = xoa_dau(item.name);
          return (
            item.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            nameNoneSign.toLowerCase().indexOf(text.toLowerCase()) > -1
          );
        })
        .slice(0, this.limit);

      this.filteredOptionsEmployee = [...filteredData];
    },
    onSelectedEmployee(option) {
      this.mainModel.inChargeEmployeeName = option.item.name;
      this.mainModel.inChargeEmployeeId = option.item.id;
    },
    async fetchEmployee() {
      // XMĐ chưa có endpoint employees/getAll — dùng users/select (BE: listUserDto + getFull)
      try {
        const response = await ApiService.query('users/select', {
          params: { getFull: true },
        });
        const employees = response.data.data || [];
        this.optionsEmployee = employees.map((element) => ({
          id: element.id,
          name: element.fullName,
          suggestionName: element.fullName,
        }));
        // Nếu PO đã load trước khi employee list về → resolve lại name
        this._resolveEmployeeName();
      } catch {
        // fail-safe: dropdown rỗng, không block luồng tạo PO
        this.optionsEmployee = [];
      }
    },
    async getPrevPriceByProductId(productId) {
      try {
        const { data } = await PurchaseOrderService.getPrevPrice(productId);
        if (data.status === API_RESPONSE_STATUS.SUCCESS) {
          const prev = data.data?.prevUnitPrice ?? 0;
          const item = this.selectedProducts.find((p) => p.id === productId);
          if (item) item.prevUnitPrice = prev;
          const inGrid = this.listProductStock.find(
            (p) => p.productId === productId,
          );
          if (inGrid) inGrid.prevUnitPrice = prev;
        }
      } catch {
        // fail-safe: giá trước đó không hiện được, không block UI
      }
    },
    checkEdit() {
      // XMĐ: BE chỉ cho update khi status NEW hoặc READY. ACCOUNTANT bị khoá (BR-001).
      const statusEditable = [
        PURCHASE_ORDER_STATUS.NEW,
        PURCHASE_ORDER_STATUS.READY,
      ];
      return statusEditable.includes(this.mainModel.status);
    },
    async loadOptions({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const result = await this.fetchProduct(searchQuery);
        const currentStoreId = this.mainModel.storeId;
        const options = (result || []).map((element) => {
          // BE products/search trả Product entity raw — productStock là array
          // chứa tồn của TẤT CẢ store (vì isCheckStock=0). Lọc theo store hiện tại.
          const storeStock = (element.productStock || []).find(
            (s) => s.storeId === currentStoreId,
          );
          const unitPrice = element.importPrice || 0;
          return {
            id: element.id,
            label: element.name,
            customLabel: '',
            productName: element.name,
            productCode: element.code,
            productType: element.type,
            // Sức bán: khởi tạo 0, fetch thực qua getPowerSaleByProductId khi thêm vào lưới.
            salePowerWeek: 0,
            salePowerMonth: 0,
            prevUnitPrice: 0,
            minPrice: 0,
            unitPrice,
            quantity: 1,
            quantityApprove: 1,
            discountAmount: 0,
            totalAmount: unitPrice,
            inStockQuantity: storeStock ? storeStock.inStockQuantity : 0,
            salePrice: element.sellingPrice || 0,
          };
        });
        callback(null, options);
      }
    },
    async onAddProduct() {
      if (!this.selectedProducts || !this.selectedProducts.length) {
        return makeToastFaile('Vui lòng chọn sản phẩm muốn thêm!');
      }

      // BE XMĐ trả productType là string enum ('SERVICE', 'DEFAULT'...) — không có COMBO.
      const isService = this.selectedProducts
        .map((product) => product.productType)
        .includes(PRODUCT_TYPE_ENUM.SERVICE);

      if (isService) {
        return makeToastFaile('Không hỗ trợ nhập kho sản phẩm dịch vụ');
      }

      const products = this.selectedProducts.map((product) => {
        return {
          ...product,
          productId: product.id,
          id: v4(),
          isNew: true,
        };
      });

      this.listProductStock = products.concat(this.listProductStock);

      // Gọi min-price cho từng SP vừa thêm (index 0..N-1 vì prepend)
      products.forEach(async (product, idx) => {
        await this.getMinPriceByProductId(product.productId, idx);
      });

      // Tính sức bán thực cho SP vừa thêm (thay cho giá trị khởi tạo 0 ở loadOptions).
      await this.getPowerSaleByProductId(products.map((p) => p.productId));

      this.selectedProducts = [];
    },
    async reportClick() {
      try {
        const response = await PurchaseOrderService.exportExcelDetail(
          this.mainModel.id,
        );
        const fileName = fileDownload.getFileName(response);
        fileDownload.createFile(response.data, fileName);
      } catch (err) {
        const msg = err.response?.data?.message || 'Không xuất được Excel';
        makeToastFaile(msg);
      }
    },
    async getMinPriceByProductId(productId, rowIndex) {
      if (!productId) return;
      try {
        const { data } = await PurchaseOrderService.getMinPrice(productId);
        if (data.status === API_RESPONSE_STATUS.SUCCESS) {
          const minPrice = Number(data.data?.minPrice) || 0;
          const row = this.listProductStock[rowIndex];
          if (row) {
            this.$set(row, 'minPrice', minPrice);
          }
        }
      } catch {
        // fail-safe: không hiện cảnh báo giá min, không block UI
      }
    },
    async getPowerSaleByProductId(productIds) {
      if (!productIds || !productIds.length) return;
      try {
        const { data } = await PurchaseOrderService.getPowerSale({
          productIds,
          storeId: this.mainModel.storeId,
        });
        if (data.status === API_RESPONSE_STATUS.SUCCESS) {
          const items = data.data || [];
          items.forEach((item) => {
            const row = this.listProductStock.find(
              (p) => p.productId === item.productId,
            );
            if (row) {
              row.salePowerWeek = item.salePowerWeek;
              row.salePowerMonth = item.salePowerMonth;
            }
          });
        }
      } catch {
        // fail-safe: sức bán không cập nhật được, không block UI
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/sass/pages/wizard/wizard-4.scss';
</style>
